import type { EffectCondition, PayloadFilter } from '../core/types';

export class ConditionEngine {
  evaluateFilter(filter: PayloadFilter, payload: Record<string, unknown>): boolean {
    const value = this.resolvePath(filter.field, payload);

    switch (filter.op) {
      case 'eq':
        return value === filter.value;
      case 'neq':
        return value !== filter.value;
      case 'in':
        return Array.isArray(filter.value) && filter.value.includes(value);
      case 'exists':
        return value !== undefined && value !== null;
      default:
        return true;
    }
  }

  evaluateCondition(
    condition: EffectCondition | undefined,
    payload: Record<string, unknown>,
  ): boolean {
    if (!condition) return true;

    if ('allOf' in condition) {
      return condition.allOf.every((c) => this.evaluateCondition(c, payload));
    }
    if ('anyOf' in condition) {
      return condition.anyOf.some((c) => this.evaluateCondition(c, payload));
    }
    if ('not' in condition) {
      return !this.evaluateCondition(condition.not, payload);
    }

    return this.evaluateFilter(condition as PayloadFilter, payload);
  }

  private resolvePath(path: string, data: Record<string, unknown>): unknown {
    const parts = path.split('.');
    let current: unknown = data;

    for (const part of parts) {
      if (current == null || typeof current !== 'object') return undefined;
      current = (current as Record<string, unknown>)[part];
    }

    return current;
  }
}
